module.exports = __webpack_public_path__ + "static/assets/22d2ca507a72b369ce926465e6cada16.svg";